import { useViewportWidth } from "@/hooks/utils/use-viewport-width";

const PAGE_HORIZONTAL_PADDING = 32;
const ACTION_AREA_WIDTH = 80;

/**
 * Returns the max horizontal swipe distance for a meal card, reactive to
 * viewport resize/orientation changes. Equals the rendered card width minus
 * the action button area.
 */
export const useSwipeDistance = (): number => {
  const viewportWidth = useViewportWidth();
  return Math.max(0, viewportWidth - PAGE_HORIZONTAL_PADDING - ACTION_AREA_WIDTH);
};
